__turbopack_context__.v({
  "messageButton": "styles-module__5cCWxq__messageButton",
});
